import { Row, CardBody } from "../App.styles";
import { SidebarLayout } from "../common";
import { Shimmer } from "../common/Loading.styles";
import DesignationItemPlaceholder from "./DesignationItemPlaceholder";

const Panel = () => (
    <CardBody className="card p-4">
        <Shimmer dark type="title" />
        <Shimmer dark />
    </CardBody>
);

const DesignationPlaceholder = () => {
    return (
        <>
            <Row>
                <SidebarLayout
                    panel={<Panel />}
                >
                    <div>
                        <ul className="list-unstyled">
                            <div>
                                <DesignationItemPlaceholder />
                                <DesignationItemPlaceholder />
                                <DesignationItemPlaceholder />
                                <DesignationItemPlaceholder />
                                <DesignationItemPlaceholder />
                            </div>
                        </ul>
                    </div>
                </SidebarLayout>
            </Row>
        </>
    );
};

export default DesignationPlaceholder;
